import React, { useEffect, useRef, useState } from "react";
import "./Book.css";
const isMobile = window.innerWidth <= 768;
const PAGE_COUNT = 11;
const imageCache = {
  cover: require("../assets/image/TSG71-2023_page0.jpg"),
  pagenone: require("../assets/image/TSG71-2023_pagenone.jpg"),
  pages: Array.from({ length: PAGE_COUNT }, (_, i) =>
    require(`../assets/image/TSG71-2023_page${i}.jpg`)
  ),
};

let preloadCompleted = false;

const preloadImages = () => {
  if (preloadCompleted) return;

  const loadPromises = [];
  const preloadImage = (src) => {
    new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = resolve;
      img.onerror = resolve;
    });
  };

  loadPromises.push(preloadImage(imageCache.cover));
  loadPromises.push(preloadImage(imageCache.pagenone));
  imageCache.pages.forEach((src) => {
    loadPromises.push(preloadImage(src));
  });

  Promise.all(loadPromises).then(() => {
    preloadCompleted = true;
  });
};

export default function BookViewer() {
  const [isReady, setIsReady] = useState(false);
  const [pageNo, setPageNo] = useState(0);
  const bookRef = useRef(null);
  const allPagesRef = useRef([]);
  const coverImageRef = useRef(null);
  useEffect(() => {
    const initialize = async () => {
      await preloadImages();
      setIsReady(true);
    };
    initialize();
  }, []);

  useEffect(() => {
    if (!isReady) return;
    const pages = allPagesRef.current;
    pages.forEach((page, index) => {
      if (!page) return;
      if (page.classList.contains("book-cover")) {
        page.style.zIndex = pageNo === 0 ? 1100 : 500;
        if (coverImageRef.current) {
          coverImageRef.current.style.zIndex = pageNo === 0 ? 1101 : 0;
        }
        return;
      }
      if (page.classList.contains("book-back-cover")) {
        page.style.zIndex = pageNo === PAGE_COUNT ? 1200 : 200;
        return;
      }
      if (!page || !page.classList.contains("book-page")) return;

      if (index < pageNo) {
        page.style.zIndex = 600 - index;
        page.style.backgroundImage = `url(${require("../assets/image/TSG71-2023_pagenone.jpg")})`;
      } else {
        page.style.zIndex = 1000 - index;
        page.style.backgroundImage = `url(${require(`../assets/image/TSG71-2023_page${
          index + 1
        }.jpg`)})`;
      }
    });
  }, [pageNo]);

  const turnLeft = () => {
    const pages = allPagesRef.current;
    const newPage = pageNo - 1;

    if (newPage >= 0) {
      pages[newPage].style.transform = "rotateY(0deg)";

      if (newPage === 0) bookRef.current.style.transform = "translateX(0px)";
      else if (newPage === PAGE_COUNT - 1)
        bookRef.current.style.transform = isMobile
          ? "translateX(17vw)"
          : "translateX(13vw)";
      setPageNo(newPage);
    }
    if (newPage === 1) {
      if (coverImageRef.current) {
        coverImageRef.current.style.display = "none";
      }
    }

    if (newPage === 0) {
      if (coverImageRef.current) {
        coverImageRef.current.src = require("../assets/image/TSG71-2023_page0.jpg");
        coverImageRef.current.style.display = "block";
      }
    }
  };

  const turnRight = () => {
    const pages = allPagesRef.current;
    const newPage = pageNo;

    if (newPage < PAGE_COUNT) {
      pages[newPage].style.transform = "rotateY(-180deg)";

      if (newPage === 0)
        bookRef.current.style.transform = isMobile
          ? "translateX(17vw)"
          : "translateX(13vw)";
      if (newPage + 1 === PAGE_COUNT)
        bookRef.current.style.transform = isMobile
          ? "translateX(32vw)"
          : "translateX(27vw)";
      setPageNo(newPage + 1);
    }
    if (newPage + 1 === 1) {
      if (coverImageRef.current) {
        coverImageRef.current.style.display = "none";
      }
    }
  };

  return (
    <div className="book-wrapper">
      <div className="book" ref={bookRef}>
        <div
          className="book-cover one-page"
          ref={(el) => (allPagesRef.current[0] = el)}
        >
          <img
            id="coverImage"
            ref={coverImageRef}
            src={require("../assets/image/TSG71-2023_page0.jpg")}
            alt="封面"
          />
        </div>

        {[...Array(PAGE_COUNT - 1)].map((_, i) => (
          <div
            key={i}
            className="book-page one-page"
            ref={(el) => (allPagesRef.current[i + 1] = el)}
          ></div>
        ))}

        <div
          className="book-back-cover one-page"
          ref={(el) => (allPagesRef.current[PAGE_COUNT - 1] = el)}
        ></div>
      </div>
      <div className="control">
        <button
          onClick={turnLeft}
          disabled={pageNo === 0}
          style={{
            backgroundColor:
              pageNo === 0
                ? "rgba(110, 110, 110, 0.5)"
                : "rgba(63, 63, 63, 0.8)",
            color: pageNo === 0 ? "darkgray" : "white",
          }}
        >
          &lt;
        </button>
        <button
          onClick={turnRight}
          disabled={pageNo === PAGE_COUNT}
          style={{
            backgroundColor:
              pageNo === PAGE_COUNT
                ? "rgba(110, 110, 110, 0.5)"
                : "rgba(63, 63, 63, 0.8)",
            color: pageNo === PAGE_COUNT ? "darkgray" : "white",
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
}
